import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { formatDuration } from '../../../utils/timeUtils';
import { CallStatusType, STATUS_TEXTS, type CallStatus } from '../../../constants/callStatusConstants';

interface CallStatusProps {
  phoneNumber: string;
  callStatus: CallStatus;
  duration: number;
  isMinimized: boolean;
  onToggleMinimize: () => void;
}

const CallStatusComponent: React.FC<CallStatusProps> = ({
  phoneNumber,
  callStatus,
  duration,
  isMinimized,
  onToggleMinimize,
}) => {
  const getStatusText = () => {
    if (callStatus === CallStatusType.CONNECTED) {
      return formatDuration(duration);
    }
    return STATUS_TEXTS[callStatus as keyof typeof STATUS_TEXTS] ?? 'Unknown';
  };

  return (
    <div className="simple-call-header">
      <div className="user-info">
        <div className="user-icon">👤</div>
        <div className="call-details">
          <div className="phone-number">{phoneNumber}</div>
          <div className="call-status">{getStatusText()}</div>
        </div>
      </div>
      <button 
        className="toggle-btn"
        onClick={onToggleMinimize}
        aria-label={isMinimized ? 'Maximize' : 'Minimize'}
      >
        <FontAwesomeIcon 
          icon={isMinimized ? faChevronUp : faChevronDown} 
          style={{ fontSize: '1rem' }} 
        />
      </button>
    </div>
  );
};

export { CallStatusType } from '../../../constants/callStatusConstants';
export default CallStatusComponent;
